import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { FormikProvider, useFormik } from "formik";
import { useEffect, useState } from "react";
import { Category, createCategory, getCategoryGroups } from "../../../../common/services/purchaseCategory.api";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import InputFormik from "../../../../common/components/form/InputFormik";

import "./CreatePurchaseCategory.scss";

type Props = {
  onClose?: () => void;
}

export default function ModalCreateCategory(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const [loading, setLoading] = useState(false);

  const handleCloseModal = () => { props.onClose && props.onClose(); }

  const initialValues = {
    name: "",
    type: "out",
    categoryGroupId: ''
  }

  const formik = useFormik({
    initialValues,
    onSubmit: async (data: Category) => {
      setLoading(true);
      const result = await createCategory(data);
      if (!result.ok && result.message) {
        notifyError(result.message);
      }
      setLoading(false);
      notifySuccess("Criado Categoria com sucesso.");
      handleCloseModal();
    }
  });

  useEffect(() => {

    async function loadGroups() {
      const result = await getCategoryGroups();
      formik.setFieldValue('categoryGroupId', result.data.find(group => group.name.match(/custos/gi))?.id as string)
    }
    loadGroups();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      className='relative text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className='text-black dark:text-black'>
        <h2 className="text-black">{'Nova Categoria'}</h2>
      </Modal.Header>
      <Modal.Body className='text-black dark:text-black'>
        <FormikProvider value={formik}>
          <InputFormik label="Nome da Categoria" name="name"></InputFormik>
        </FormikProvider>
        <div className="containerButtonCategory">
          <ButtonWithLoader isLoading={loading} onClick={formik.handleSubmit}>Cadastrar</ButtonWithLoader>
        </div>
      </Modal.Body>
    </Modal>
  )
}